<template>
  <div class="about2">
    <!--顶部介绍-->
    <picture>
      <source media="(min-width: 768px)" srcset="@/assets/img/pc/about/about2/bakTop.png">
      <source media="(min-width: 320px)" srcset="@/assets/img/mobile/about/about2/bakTop.png">
      <img class="bakTop" src="@/assets/img/pc/about/about2/bakTop.png">
    </picture>
    <guide :guide="guide" :color="'rgb(90, 137, 227)'" style="position: relative;top: 2rem;"></guide>
    <!--主体内容-->
    <div class="x-container">
      <!--搜索框-->
      <div class="no-data" v-if="showNoData">
        暂无数据
      </div>
      <!--产品资料-->
      <template v-for="(material, index) in materialList">
        <section :key="'material' + index" class="services" v-if="material.length > 0">
          <p>{{ labelMap[index] }}</p>
          <div class="flexContainer">
            <div class="flexBox" v-for="(item, i) in material" :key="'materialItem' + index + '-' + i">
              <div class="inlineBlock" @click.prevent="downLoad(item.label)">
                <img src="@/assets/img/pc/serve/serve2/download.png" alt="">
                <span>{{ item.label }}</span>
                <!--<span @click="downLoad(item.link)">{{item.label}}</span>-->
              </div>
            </div>
          </div>
          <div class="more" v-if="material.length >= 10" @click="goToDetail(index)">更多</div>
        </section>
      </template>
    </div>
  </div>
</template>

<script>
import guide from '@/components/guide'
import { getPublishedFileList, getPublishedFileListLimit } from '@/api/download'
import { exportMethod, exportMethod2 } from '@/utils/fileExports'
import qs from 'qs'
import { mapActions, mapGetters } from "vuex";
export default {
  name: "solution1",
  components: {
    guide,
  },
  computed: {
    showNoData() {
      if (this.materialList[0].length <= 0 && this.materialList[1].length <= 0 && this.materialList[2].length <= 0) {
        return true;
      }
      return false;
    },
    ...mapGetters(['getUserName'])
  },
  data() {
    return {
      guide: [
        // {label: '格力绿控网'},
        { label: '服务与支持' },
        { label: '资料下载' },
      ],
      labelPosition: "left",
      form: {
        // 搜索框
        product: [],
        solution: [],
        service: []
      },
      keyMap: {
        1: "service",
        2: "product",
        3: 'solution'
      },
      materialList: [
        [], [], []
      ],
      labelMap: ['服务指导', '产品资料', '解决方案']
    }
  },
  methods: {
    ...mapActions(['openLoginDailog']),
    goToDetail(index) {
      let fileType = index + 1;
      this.$router.push('/serve/downloadDetail/' + fileType);
    },
    downLoad(fileName) {
      if (this.getUserName) {  // 已登录才可以下载
        let obj = {
          url: 'api/file/downloadFile',
          method: 'get',
          params: qs.stringify({
            fileName: fileName
          })
        }
        exportMethod2(obj);
      } else {  // 未登录则弹出登录框
        this.openLoginDailog();
      }
    },

    /**
     * @Description: 获取列表
     * @author Li Yanjie
     * @date 2020/7/18
     * @param fileType {Number} 文件类型：1-服务指导，2-产品资料，3-解决方案
     * @return
    */
    getPublishedFileListLimit(fileType) {
      getPublishedFileListLimit(fileType).then(res => {
        if (res.returnCode === "100") {
          let arr = [];
          res.returnData.map(item => {
            arr.push({
              label: item.fileName,
            })
          });
          this.$set(this.materialList, fileType - 1, arr);
        } else {
          this.$set(this.materialList, fileType - 1, []);
        }
      }).catch(e => {

      })
    }
  },
  mounted() {
    this.getPublishedFileListLimit(1);
    this.getPublishedFileListLimit(2);
    this.getPublishedFileListLimit(3);
  }
}
</script>

<style scoped lang="less">
.x-container {
  section {
    width: 80%;
    margin: auto;
    margin-bottom: 2rem;
  }
}

/*搜索框*/
.form {
  text-align: center;
  width: 100%;
  box-sizing: border-box;
}

/*服务指导*/
.services {
  background: #fff;
  min-height: 15rem;
  padding-bottom: 2rem;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  position: relative;

  .more {
    color: rgb(90, 137, 227);
    cursor: pointer;
    font-size: 16px;
    margin: 4px auto;
    border-radius: 20px;
    border: 1px solid;
    width: 100px;
    padding: 6px 0;
  }

  p {
    color: @deepblue;
    text-align: center;
    padding: 1rem;
    border-bottom: 1px solid rgba(170, 164, 164, 0.29);
  }

  .flexContainer {
    display: flex;
    flex-wrap: wrap;
    padding: 1rem;

    .flexBox {
      margin-bottom: 1rem;
      text-align: left;
      display: block;
      width: 50%;
      cursor: pointer;

      img {
        margin-right: 10px;
      }

      span {
        font-size: 0.8rem;
      }
    }
  }

  @media only screen and (min-width: 320px) {
    .more {
      font-size: 14px;
    }

    .flexContainer .flexBox {
      width: 100%;
    }
  }

  @media only screen and (min-width: 768px) {
    .more {
      font-size: 16px;
    }

    .flexContainer .flexBox {
      width: 50%;
    }
  }
}

/*头部背景图*/
.bakTop {
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
}
</style>
<style lang="less" scoped>
.x-container {

  /*搜索框*/
  .searchBox {
    .el-form--inline .el-form-item__label {
      color: @deepblue;
      font-size: 1rem;
    }

    .el-input__inner {
      border: 1px solid @blue;
      border-radius: 0;
    }

    /*搜索框*/
    .search {
      .el-form-item__content {
        width: 100%;

        .el-select {
          width: 100%;
        }
      }
    }

    .el-textarea__inner {
      min-height: 10rem !important;
      border: 1px solid @blue;
      border-radius: 0;
    }
  }
}

.inlineBlock {
  display: inline-block;
}
</style>
